import React from 'react';
import { 
  LineChart, Line, PieChart, Pie, Cell, 
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer 
} from 'recharts';

export default function HRDashboard() {
  // Mock Data
  const headcountData = [
    { name: 'Dec', value: 95 },
    { name: 'Jan', value: 110 },
    { name: 'Feb', value: 125 },
    { name: 'Mar', value: 130 },
    { name: 'Apr', value: 150 },
    { name: 'May', value: 286 },
  ];

  const departmentData = [
    { name: 'Engineering', value: 98, color: '#6B46C1' },
    { name: 'Product', value: 72, color: '#9F7AEA' },
    { name: 'Sales', value: 50, color: '#D6BCFA' },
    { name: 'Marketing', value: 36, color: '#63B3ED' },
    { name: 'HR', value: 28, color: '#81E6D9' },
  ];

  const funnelData = [
    { stage: 'Application', count: 142, width: '100%', color: '#6B46C1' },
    { stage: 'Interview', count: 85, width: '80%', color: '#8B5CF6' },
    { stage: 'Offer', count: 34, width: '60%', color: '#A78BFA' },
    { stage: 'Hired', count: 12, width: '40%', color: '#C4B5FD' },
    { stage: 'Joined', count: 5, width: '25%', color: '#DDD6FE' },
  ];

  const birthdays = [
    { date: 'Jun 5', name: 'Sarah Johnson', dept: 'Marketing', avatar: 'SJ' },
    { date: 'Jun 7', name: 'Michael Chen', dept: 'Engineering', avatar: 'MC' },
    { date: 'Jun 12', name: 'Priya Patel', dept: 'Product', avatar: 'PP' },
  ];

  const leaves = [
    { type: 'Vacation', days: 157, max: 200, color: '#6B46C1' },
    { type: 'Sick Leave', days: 42, max: 200, color: '#8B5CF6' },
    { type: 'Personal', days: 26, max: 200, color: '#A78BFA' },
    { type: 'Unpaid', days: 0, max: 200, color: '#C4B5FD' },
  ];

  const documents = [
    { name: 'Employee Handbook', date: 'Updated May 28, 2026' },
    { name: 'Leave Policy', date: 'Updated May 15, 2026' },
    { name: 'Code of Conduct', date: 'Updated May 1, 2026' },
  ];

  return (
    <div style={{ padding: '24px', backgroundColor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', margin: 0 }}>HR</h1>
        <div style={{ display: 'flex', gap: '12px' }}>
          <select style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '14px', outline: 'none' }}>
            <option>All Departments</option>
          </select>
          <button style={{ padding: '8px 20px', borderRadius: '8px', border: 'none', backgroundColor: '#6B46C1', color: '#fff', fontSize: '14px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>+</span> Add Employee
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' }}>
        {/* Headcount */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ color: '#4B5563', fontSize: '14px', marginBottom: '8px' }}>Headcount</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>286</div>
              <div style={{ color: '#059669', fontSize: '12px', fontWeight: '500', whiteSpace: 'nowrap' }}>+12 vs last month</div>
            </div>
            <div style={{ width: '40px', height: '40px', backgroundColor: '#EDE9FE', color: '#6B46C1', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
              👥
            </div>
          </div>
        </div>
        
        {/* Attendance Rate */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ color: '#4B5563', fontSize: '14px', marginBottom: '8px' }}>Attendance Rate</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>96.4%</div>
              <div style={{ color: '#059669', fontSize: '12px', fontWeight: '500', whiteSpace: 'nowrap' }}>+2.1% vs last month</div>
            </div>
            <div style={{ width: '40px', height: '40px', backgroundColor: '#D1FAE5', color: '#059669', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
              ✓
            </div>
          </div>
        </div>

        {/* Open Positions */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ color: '#4B5563', fontSize: '14px', marginBottom: '8px' }}>Open Positions</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>18</div>
              <div style={{ color: '#DC2626', fontSize: '12px', fontWeight: '500', whiteSpace: 'nowrap' }}>+2 vs last month</div>
            </div>
            <div style={{ width: '40px', height: '40px', backgroundColor: '#EDE9FE', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
              📋
            </div>
          </div>
        </div>

        {/* Monthly Payroll */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ color: '#4B5563', fontSize: '14px', marginBottom: '8px' }}>Monthly Payroll</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#111827', marginBottom: '4px' }}>$512,340</div>
              <div style={{ color: '#6B7280', fontSize: '12px', whiteSpace: 'nowrap' }}>May 2026</div>
            </div>
            <div style={{ width: '40px', height: '40px', backgroundColor: '#EDE9FE', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
              💵
            </div>
          </div>
        </div>
      </div>

      {/* Middle Row: Charts */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '20px' }}>
        
        {/* Headcount Overview */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 16px 0', color: '#111827' }}>Headcount Overview</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#6B7280', marginBottom: '16px', justifyContent: 'center' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#6B46C1' }}></div> Total Employees
          </div>
          <div style={{ height: '200px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={headcountData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} dy={10} />
                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} dx={-10} domain={[0, 200]} />
                <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                <Line type="monotone" dataKey="value" stroke="#6B46C1" strokeWidth={3} dot={{ r: 4, fill: '#fff', stroke: '#6B46C1', strokeWidth: 2 }} activeDot={{ r: 6 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Department Breakdown */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 20px 0', color: '#111827' }}>Department Breakdown</h3>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '160px', height: '160px', position: 'relative' }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={departmentData} innerRadius={50} outerRadius={75} paddingAngle={2} dataKey="value" stroke="none">
                    {departmentData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                </PieChart>
              </ResponsiveContainer>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827' }}>286</div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>Total</div>
              </div>
            </div>
            <div style={{ flex: 1, paddingLeft: '16px' }}>
              {departmentData.map((item, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', fontSize: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#4B5563' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: item.color }}></div>
                    {item.name}
                  </div>
                  <div style={{ color: '#111827', fontWeight: '500' }}>
                    {item.value} <span style={{ color: '#9CA3AF', fontWeight: 'normal', marginLeft: '4px' }}>({((item.value / 286) * 100).toFixed(1)}%)</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recruitment Funnel */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 20px 0', color: '#111827' }}>Recruitment Funnel</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center', marginTop: '10px' }}>
            {funnelData.map((stage, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '12px' }}>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  <div style={{ 
                    width: stage.width, 
                    backgroundColor: stage.color, 
                    color: '#fff', 
                    fontSize: '12px', 
                    padding: '6px 0', 
                    textAlign: 'center', 
                    borderRadius: '4px',
                    minWidth: '60px'
                  }}>
                    {stage.stage}
                  </div>
                </div>
                <div style={{ width: '30px', fontSize: '13px', color: '#4B5563', fontWeight: '500', textAlign: 'right' }}>
                  {stage.count}
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: '#4B5563', fontWeight: '500' }}>
            Conversion Rate: 4.2%
          </div>
        </div>

      </div>

      {/* Bottom Row: Lists & progress */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
        
        {/* Upcoming Birthdays */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 20px 0', color: '#111827' }}>Upcoming Birthdays</h3>
          <div>
            {birthdays.map((b, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', fontSize: '13px' }}>
                <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', color: '#6B7280', marginRight: '12px' }}>
                  {b.avatar}
                </div>
                <div style={{ color: '#4B5563', width: '45px' }}>{b.date}</div>
                <div style={{ color: '#111827', fontWeight: '500', flex: 1, marginLeft: '8px' }}>{b.name}</div>
                <div style={{ color: '#6B7280' }}>{b.dept}</div>
              </div>
            ))}
          </div>
          <button style={{ color: '#6B46C1', background: 'none', border: 'none', fontSize: '13px', fontWeight: '500', cursor: 'pointer', padding: 0, marginTop: '8px' }}>
            View all birthdays →
          </button>
        </div>

        {/* Leave Overview */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 20px 0', color: '#111827' }}>Leave Overview</h3>
          <div>
            {leaves.map((lv, idx) => (
              <div key={idx} style={{ marginBottom: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '6px' }}>
                  <span style={{ color: '#111827', fontWeight: '500' }}>{lv.type}</span>
                  <span style={{ color: '#4B5563' }}>{lv.days} days left</span>
                </div>
                <div style={{ height: '6px', backgroundColor: '#F3F4F6', borderRadius: '3px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${(lv.days / lv.max) * 100}%`, backgroundColor: lv.color, borderRadius: '3px' }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Documents */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #F3F4F6', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: '0 0 20px 0', color: '#111827' }}>Recent Documents</h3>
          <div>
            {documents.map((doc, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: '#F3E8FF', color: '#6B46C1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', marginRight: '12px', flexShrink: 0 }}>
                  📄
                </div>
                <div>
                  <div style={{ color: '#111827', fontSize: '13px', fontWeight: '500', marginBottom: '4px' }}>{doc.name}</div>
                  <div style={{ color: '#6B7280', fontSize: '12px' }}>{doc.date}</div>
                </div>
              </div>
            ))}
          </div>
          <button style={{ color: '#6B46C1', background: 'none', border: 'none', fontSize: '13px', fontWeight: '500', cursor: 'pointer', padding: 0 }}>
            View all documents →
          </button>
        </div>

      </div>

    </div>
  );
}
